import { Reveal } from "./Reveal";
import AuditForm from "./AuditForm";
import { PromoVideo } from "./PromoVideo";

export default function QuickForm() {
  return (
    <section id="pieteikties" data-testid="quick-form-section" className="bg-[#FCC08A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 md:py-24 grid lg:grid-cols-[1.1fr_auto_1.2fr] gap-12 items-center">
        <Reveal>
          <span className="text-xs font-semibold uppercase tracking-[0.3em] text-[#ED1C27]">Pieteikties</span>
          <h2 className="mt-4 font-display font-black tracking-tighter leading-[1.02] text-3xl sm:text-4xl lg:text-5xl text-[#003E75]" data-testid="quick-form-heading">
            Saņemiet bezmaksas baneru un video auditu
          </h2>
          <p className="mt-5 text-[#003E75]/75 text-base leading-relaxed max-w-md">
            Aizpildiet pieteikumu. Mūsu komanda sazināsies ar Jums un vienojas par kreatīvu
            nosūtīšanu izvērtēšanai.
          </p>
          <p className="mt-5 text-xs text-[#003E75]/60" data-testid="quick-form-qualifiers">
            Gada apgrozījums no €500 000&nbsp;&nbsp;•&nbsp;&nbsp;Reklāmas budžets no
            €2 000/mēn.&nbsp;&nbsp;•&nbsp;&nbsp;Bez maksas&nbsp;&nbsp;•&nbsp;&nbsp;Bez saistībām
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <PromoVideo />
        </Reveal>
        <Reveal delay={0.1}>
          <AuditForm testidPrefix="quick-audit-form" />
        </Reveal>
      </div>
    </section>
  );
}
